import { type FC, useEffect, useRef } from "react";

export const Turnstile: FC<{
  sitekey: string;
  onTokenize(token: string): void;
}> = ({ sitekey, onTokenize }) => {
  const ref = useRef<HTMLDivElement>(null);
  const callback = useRef(onTokenize);

  useEffect(() => {
    callback.current = onTokenize;
  }, [onTokenize]);

  useEffect(() => {
    if (typeof turnstile === "undefined") return;
    if (!ref.current) return;

    const widgetID = turnstile.render(ref.current, {
      sitekey,
      size: "flexible",
      callback: (token: string) => {
        callback.current(token);
      },
    });

    console.log("widgetID", widgetID);

    return () => {
      if (widgetID) turnstile.remove(widgetID);
    };
  }, [sitekey]);

  return <div ref={ref} />;
};
